const SEO = [
	{
		page: "home",
		description:
			"I am a Data Scientist with expertise in Python and use of TensorFlow Framework. I have experience in building scalable, and reliable Machine Learning Model for web applications using Google Cloud Platform and other technologies, such as AWS Sage Maker.",
		keywords: ["Anthony", "Anthony Suryajaya", "Anthony S"],
	},

	{
		page: "about",
		description:
			"I am a Data Scientist/Machine Learning Engineer with expertise in Python and TensorFlow. I have experience in building scalable, and reliable Machine Learning Models for web applications using various frameworks and technologies.",
		keywords: ["Anthony", "Anthony Suryajaya", "Anthony S"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Anthony", "Anthony Suryajaya", "Anthony S"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Anthony", "Anthony Suryajaya", "Anthony S"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Anthony", "Anthony Suryajaya", "Anthony S"],
	},
];

export default SEO;
